<template>
  <div>
    <v-navigation-drawer
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
            v-if="showNavigation"
    >
      <v-list dense v-if="isShowMenu">
        <v-list-item
            v-for="(child, i) in items[0].children"
            :key="i"
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="openItem(child)" class="handpointer">
              {{ child.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--
        <template v-for="item in items">
          <v-row
                  v-if="item.heading"
                  :key="item.id"
                  align="center"
          >
            <v-col cols="6">

            </v-col>
          </v-row>
          <v-list-group
                  v-else-if="item.children"
                  :key="item.text"
                  v-model="item.model"
                  :prepend-icon="item.model ? item.icon : item['icon-alt']"
                  append-icon=""
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
                    v-for="(child, i) in item.children"
                    :key="i"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title @click="openItem(child)" class="handpointer">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
                  v-else
                  :key="item.text"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            style="z-index:101;"
            color="black"
            dark
    >
      <v-toolbar-title
              style="width: 300px"
              class="ml-0 pl-4"
      >
        <v-app-bar-nav-icon v-if="showNavigation" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <!--<span class="hidden-sm-and-down">{{ApplicationName}}
        </span>-->
        <v-avatar
                size="40px"
                item
                tile
                class="mx-2"
        >
          <v-img
                  src="/static/Logo_Play.png"
                  alt="Kermax"
          >
          </v-img>
        </v-avatar>
      </v-toolbar-title>
      <v-text-field
              flat
              v-if="showSearch"
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="Search"
              class="hidden-sm-and-down"
      ></v-text-field>
      <div class="flex-grow-1"></div>
      <v-btn icon v-if="showApps">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon v-if="showNotify">
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon large class="mr-2" to="/">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="ml-4 mt-4">
      <v-content class="pt-12 mx-4">
        <router-view/>
      </v-content>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Dashboard',
  components: {},
  props: {
    source: String
  },
  data: () => ({
    numberOfItemsCard: '15 Items',
    titleGeraete: 'Mein Gerät ...',
    playlistName: 'Name der Playlist',
    model1: null,
    dialog: false,
    showNavigation: false,
    value: '',
    forename: '',
    lastname: '',
    drawer: null,
    userData: '',
    isShowMenu: false,
    model: '',
    ApplicationName: 'Kermax',
    showSearch: false,
    showNotify: false,
    showApps: false,
    items: [
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Navigation',
        id: '1',
        model: 'true',
        children: []
      }
      /* ,
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Admin',
        id: '2',
        model: 'true',
        children: [
          {icon: 'supervisor_account', text: 'Benutzer', url: '/Dashboard/Benutzer'}
        ],
      } */
    ],
      netzwerke: {
          color: '#fcbf00',
          numberNetzwerke: '3489',
      },
      playlist: {
          color: '#1B5E20',
          numberPlaylist: '23769',
      },
      geraete: {
          color: '#E65100',
          numberGeraete: '534',
      },
      benutzer: {
          color: '#26C6DA',
          numberBenutzer: '78',
      },
  }),
  methods: {
    openDialog: function () {
      this.$refs.dlgVideo.open()
    },
    openDialogHoch: function () {
      this.$refs.dlgVideoHoch.open()
      },
    openItem: function (item) {
      console.log('open item', item)
      this.$router.push(item.url)
    },
    open: function () {
    },
    goToNetzwerke: function () {
      this.$router.push('/Dashboard/Netzwerke')
    },
    goToPlaylist: function () {
       this.$router.push('/Dashboard/Playlist')
    },
    goToGeraete: function () {
       this.$router.push('/Dashboard/Geraete')
    },
    goToBenutzer: function () {
       this.$router.push('/Dashboard/Benutzer')
      }
  },
  mounted () {
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_DASHBOARD')) {
        this.items[0].children.push({icon: 'dashboard', text: 'Dashboard', url: '/Dashboard/Main'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_NETWORK')) {
      this.items[0].children.push({icon: 'business', text: 'Netzwerke', url: '/Dashboard/Netzwerke'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_PLAYLIST')) {
      this.items[0].children.push({icon: 'play_circle_outline', text: 'Playlist', url: '/Dashboard/Playlist'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_CHANNELS')) {
      this.items[0].children.push({icon: 'poll', text: 'Channels', url: '/Dashboard/Channels'})
      this.items[0].children.push({icon: 'mdi-multimedia', text: 'Mediathek', url: '/Dashboard/Mediathek'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_DEVICES')) {
      this.items[0].children.push({icon: 'devices', text: 'Geräte', url: '/Dashboard/Geraete'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_USER')) {
      this.items[0].children.push({icon: 'people', text: 'Benutzer', url: '/Dashboard/Benutzer'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_ROLES')) {
      this.items[0].children.push({icon: 'person', text: 'Rollen', url: '/Dashboard/Rollen'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_ROLES')) {
      this.items[0].children.push({icon: 'edit', text: 'Templates', url: '/Dashboard/Templates'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_ROLES')) {
      this.items[0].children.push({icon: 'device_hub', text: 'Rechte', url: '/Dashboard/Rechte'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_APPS')) {
      this.items[0].children.push({icon: 'subscriptions', text: 'App Versionen', url: '/Dashboard/Apps'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_MEDIA')) {
      this.items[0].children.push({icon: 'movie', text: 'Medien', url: '/Dashboard/Medien'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_MAILS')) {
      this.items[0].children.push({icon: 'mail', text: 'Mails', url: '/Dashboard/Mails'})
    }
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_SUPPORT')) {
      this.items[0].children.push({icon: 'help', text: 'Support', url: '/Dashboard/Support'})
    }
    this.isShowMenu = true
    this.userData = Vue.prototype.$api.getCredentials().data
    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_NAVIGATION')) {
      this.showNavigation = true
    }


  }
}
</script>

<style scoped>

</style>
